import { Component, OnInit, ViewContainerRef, ElementRef, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { Organization } from '../../../../app/_models/Organization';
import { OrganizationService } from '../../../../app/_services/organization.service';


@Component({
  selector: 'app-organizations-form',
  templateUrl: './organizations-form.component.html',
  styleUrls: ['./organizations-form.component.css'],
})

export class OrganizationsFormComponent implements OnInit {
  public form: FormGroup;
  public loadingMessage = 'Loading organization data...';

  private organization: Organization = {
    name: 'Generic Org',
    active: false
  };


  public formLoaded: boolean;

  @ViewChild('barcodeImage')
  barImg: ElementRef;

  constructor(private fb: FormBuilder,
    public viewRef: ViewContainerRef,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router,
    private organizationService: OrganizationService
  ) {

  }

  ngOnInit() {
    this.loadingMessage = 'Loading organization data...';
    this.spinner.show();

    this.activatedRoute.params.subscribe(params => {
      const id = params['id'];
      if (id) {
        this.organizationService.getOrganization(id).toPromise().then(
          data => {
            this.initializeForm(data);
            this.spinner.hide();
            this.formLoaded = true;
          });
      } else {
        this.initializeForm(this.organization);
        this.spinner.hide();
        this.formLoaded = true;
      }
    });
  }

  createOrUpdateOrganization() {

    this.loadingMessage = this.organization.organizationId ? 'Updating organization...' : 'Creating organization...';
    this.spinner.show();
    this.organizationService.createOrganization(Object.assign({}, this.form.value)).toPromise().then(() => {
      this.spinner.hide();
      this.router.navigate(['/portal/admin/organization']);
    });
  }

  cancel() {
    this.router.navigate(['/portal/admin/organization']);
  }

  private initializeForm(organization: Organization) {
    this.organization = organization;

    this.form = this.fb.group({
      name: organization.name,
      organizationId: organization.organizationId,
      active: organization.active
    });
  }
}
